<template>
    <div>
        <v-tabs
                slot="extension"
                v-model="model"
                centered
                color="secondary"
                slider-color="primary"
                class="elevation-10"
        >
            <v-tab
                    href="#tab-data"
            >
                Laboratory Data
            </v-tab>
            <v-tab
                    href="#tab-ftn"
            >
                Contacts
            </v-tab>
            <v-tab
                    href="#tab-clientes"
            >
                Clients
            </v-tab>
        </v-tabs>

        <v-tabs-items
                v-model="model"
                class="elevation-10"
        >
            <v-tab-item
                    value="tab-data"
                    lazy
                    :transition="false"
                    :reverse-transition="false"
            >
                <v-card flat>
                    <DataComponent v-if="model == 'tab-data'" :id="id"></DataComponent>
                </v-card>
            </v-tab-item>
            <v-tab-item
                    value="tab-ftn"
                    lazy
                    :transition="false"
                    :reverse-transition="false"
            >
                <v-card flat>
                    <FtnsComponent v-if="model == 'tab-ftn'" :id="id"></FtnsComponent>
                </v-card>
            </v-tab-item>
            <v-tab-item
                    value="tab-clientes"
                    lazy
                    :transition="false"
                    :reverse-transition="false"
            >
                <v-card flat>
                    <ClientesComponent v-if="model == 'tab-clientes'" :id="id"></ClientesComponent>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<script>
    import DataComponent from './view/DataComponent';
    import FtnsComponent from './view/FtnsComponent';
    import ClientesComponent from './view/ClientesComponent';

    export default {
        props: ['id'],
        data () {
            return {
                model: 'tab-data'
            }
        },
        created () {
            this.setSectionTitle();
        },
        methods: {
            setSectionTitle () {
                this.$store.dispatch('setSectionTitle', {
                    title: 'Laboratory detail.'
                });
            },
        },
        components: {
            DataComponent,
            FtnsComponent,
            ClientesComponent
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/amcs/DetailComponet.vue